import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import HeroNameSelector from "TaskDialogCommon/HeroNameSelector";
import TaskInput from "TaskDialogCommon/TaskInput";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import errordialog from "Common/errordialog";
import TroopMapSelector from "TaskDialogCommon/TroopMapSelector";
import GKMapSelector from "TaskDialogCommon/GKMapSelector";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import IconButton from "@material-ui/core/IconButton";
import ReactFileReader from "react-file-reader";
import base64 from "base-64";
import toastMaker from "Common/toastmaker";
import { getLastConfigForTask } from "Utils/Common";
import { TROOP_NAMES } from "Utils/Common";

const taskname = "schscustomrun";

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    const initialState = {
      taskConfig: {
        accountdetail: accountdetailrow,
        mapstodo: [],
        unboxtroops: true,
        poprunesmins: 0,
      },
    };
    logger.log(`loading ${taskname} dialog`, props);
    this.loadStoredData(initialState, props);
    logger.log("initialState after load", initialState);
    this.state = initialState;
  }

  validate = () => {
    const {
      taskConfig: { mapstodo },
    } = this.state;
    if (!mapstodo || mapstodo.length === 0) {
      alert("Please add atleast one step before continuing");
      return false;
    }
    return true;
  };

  loadStoredData = (initialState, props) => {
    const { taskConfig } = initialState;
    try {
      const { AccountDetailData: accountdetail } = props;
      var storeddata = getLastConfigForTask(taskname);
      logger.log("storeddata", storeddata, accountdetail);
      if (storeddata) {
        taskConfig.mapstodo = storeddata.mapstodo;
        taskConfig.unboxtroops = storeddata.unboxtroops;
        taskConfig.poprunesmins = storeddata.poprunesmins;
      }
    } catch (e) {
      logger.log(e);
    }
  };

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  setTaskConfigChanges = (taskConfigChanges, callBack) => {
    this.setState(
      (s, p) => ({
        taskConfig: { ...s.taskConfig, ...taskConfigChanges },
      }),
      callBack
    );
  };

  deleteSelectedStep = (index) => {
    const mapstodo = [...this.state.taskConfig.mapstodo];
    mapstodo.splice(index, 1);
    this.setValue({ target: { value: mapstodo } }, "mapstodo");
  };

  downloadTxtFile = () => {
    const element = document.createElement("a");
    const { mapstodo, unboxtroops, poprunesmins } = this.state.taskConfig;
    const exportData = {
      taskname,
      mapstodo,
      unboxtroops,
      poprunesmins,
    };
    const file = new Blob(
      [base64.encode(JSON.stringify(exportData, null, 4))],
      {
        type: "text/plain",
      }
    );
    element.href = URL.createObjectURL(file);
    element.download = "SCHSCustomConfigExport.hgconfig";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  handleFiles = (files) => {
    logger.log(files);
    var reader = new FileReader();
    reader.onload = (e) => {
      var storeddata = JSON.parse(base64.decode(reader.result));
      logger.log("storeddata loaded from file", storeddata);
      if (storeddata) {
        const taskConfig = { ...this.state.taskConfig };
        if (taskname !== storeddata.taskname) {
          alert("Config does not belong to this task.");
          return;
        }
        logger.log("taskConfig", taskConfig);
        taskConfig.mapstodo = storeddata.mapstodo;
        taskConfig.unboxtroops = storeddata.unboxtroops;
        taskConfig.poprunesmins = storeddata.poprunesmins;
        this.setTaskConfigChanges(taskConfig, () => {
          toastMaker.makeToast("Config loaded successfully!", {
            variant: "success",
          });
        });
      }
    };
    reader.readAsText(files[0]);
  };

  render = () => {
    const {
      setValue,
      validate,
      state: { taskConfig },
      props: { AccountDetailData },
    } = this;
    if (AccountDetailData.heroes === undefined) {
      errordialog.showError(
        "Hero Data Not Found. Please refresh or contact administrator."
      );
      return null;
    }

    return (
      <TaskDialog heading={"Customised SCHS Run"}>
        {taskConfig.mapstodo.map((item, index) => {
          return (
            <div
              style={{ border: "1px solid", padding: "5px", display: "flex" }}
            >
              <div style={{ float: "left", flex: "1" }}>Step: {index + 1}</div>
              <div style={{ float: "auto", flex: "2" }}>
                {item.level.levelname}
                <br />
                {item.heroToUse}
                <br />
                {Object.keys(item.troops).map((key) => {
                  return (
                    <>
                      {TROOP_NAMES[key]}:{item.troops[key]}
                      <br />
                    </>
                  );
                })}
              </div>
              <div style={{ flex: "1" }}>
                <IconButton
                  color="#000000"
                  onClick={() => this.deleteSelectedStep(index)}
                  size={"small"}
                >
                  <HighlightOffIcon />
                </IconButton>
              </div>
            </div>
          );
        })}
        <div style={{ border: "1px solid", padding: "5px" }}>
          <HeroNameSelector
            label={"Select Hero"}
            AccountDetailData={AccountDetailData}
            taskConfig={taskConfig}
            setValue={setValue}
            param={"heroToUse"}
          />
          <GKMapSelector
            label={"Select Map"}
            preselectedMap="SCHS"
            taskConfig={taskConfig}
            setValue={setValue}
            setTaskConfigChanges={this.setTaskConfigChanges}
          />
          <TroopMapSelector
            AccountDetailData={AccountDetailData}
            taskConfig={taskConfig}
            setValue={setValue}
            label={"Add Troops To Send"}
            param={"troops"}
          />

          <button
            onClick={() => {
              if (!taskConfig.level) {
                alert("Please select a level before adding");
                return;
              }
              if (!taskConfig.heroToUse) {
                alert("Please select a hero before adding");
                return;
              }
              if (!taskConfig.troops) {
                alert("Please select troops before adding");
                return;
              }
              const newConfig = {
                level: { ...taskConfig.level },
                heroToUse: taskConfig.heroToUse,
                troops: { ...taskConfig.troops },
              };
              const mapstodo = [...taskConfig.mapstodo, newConfig];
              setValue({ target: { value: mapstodo } }, "mapstodo");
            }}
          >
            Add Step
          </button>
        </div>

        <TaskInput
          label={"Auto Pop 200% Runes for mins(Optional)"}
          value={taskConfig.poprunesmins}
          onChange={(event) => setValue(event, "poprunesmins")}
        />

        <TaskCheckBox
          label={"Auto Unbox Troops when needed."}
          param={"unboxtroops"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Run Custom SCHS"}
          validate={validate}
          test={false}
        />
        <div style={{ display: "flex" }}>
          <button onClick={this.downloadTxtFile}>Save config to file</button>
          <ReactFileReader
            handleFiles={this.handleFiles}
            fileTypes={".hgconfig"}
            base64={false}
            multipleFiles={false}
          >
            <button className="btn">Load Config from file</button>
          </ReactFileReader>
        </div>
      </TaskDialog>
    );
  };
}
